package ru.it_mozaika.sender.js.application.components.subscribers

import mui.material.*
import mui.system.responsive
import mui.system.sx
import react.*
import react.dom.aria.AriaRole
import ru.it_mozaika.sender.common.models.TableColumn
import ru.it_mozaika.sender.js.application.context.StoreContext
import web.cssom.*

external interface FieldSelectDialogProps: Props {
    var columns: List<TableColumn>
    var primaryKey: List<String>
    var selectedFields: List<String>
    var onClose: () -> Unit
    var isOpen: Boolean
    var changeHandler: (List<String>) -> Unit
    var onSwapHandler: (List<String>) -> Unit
}

val fieldSelectDialog = FC<FieldSelectDialogProps> { props ->
    val (selected, setSelected) = useState<List<String>>(listOf())
    val (fieldsOrder, setFieldsOrder) = useState<List<String>>(listOf())
    val onSwapHandler: (String, Int) -> Unit = { column, step ->
        val currentIndex = fieldsOrder.indexOfFirst { it == column }
        if (currentIndex + step >= 0 && (currentIndex + step <= (fieldsOrder.size - 1))) {
            val currentItem = fieldsOrder[currentIndex + step]
            setFieldsOrder { current ->
                val newList = current.toMutableList()
                newList[currentIndex] = currentItem
                newList[currentIndex + step] = column
                newList
            }
        }
    }
    useEffect(props.columns, props.selectedFields) {
       if (props.selectedFields != selected) setSelected(props.selectedFields)
        setFieldsOrder(props.columns.map { it.name })
    }
    Dialog {
        sx {
            marginTop = 52.px
            marginBottom = 5.px
            "& .MuiPaper-root" {
                minWidth = 500.px
            }
        }
        this.open = props.isOpen
        DialogTitle {
            +"Выберите поля:"
        }
        DialogContent {
            Divider()
            List {
                sx {
                    width = 100.pct
                }
                ListItem {
                    sx {
                        position = Position.sticky
                    }
                    key = "select-all"
                    disablePadding = true
                    ListItemButton {
                        role = AriaRole.checkbox
                        dense = true
                        onClick = { _ ->
                            if (selected.size == props.columns.size) {
                                setSelected(props.primaryKey)
                            } else {
                                setSelected(props.columns.map{ it.name })
                            }
                        }
                        ListItemIcon {
                            Checkbox {
                                checked = selected.size == props.columns.size
                                disableRipple = true
                                tabIndex = -1
                                color = CheckboxColor.secondary
                                indeterminate = selected.size < props.columns.size
                            }
                        }
                        ListItemText {
                            primary =
                                ReactNode(if (selected.size == props.columns.size) "Очистить все" else "Выбрать всё")
                        }
                    }
                }
                props.columns.forEach { column ->
                    ListItem {
                        key = column.name
                        disablePadding = true
                        ListItemButton {
                            role = AriaRole.checkbox
                            dense = true
                            onClick = { _ ->
                                setSelected { list ->
                                    if (list.contains(column.name)) list.minus(column.name) else list.plus(column.name)
                                }
                            }
                            ListItemIcon {
                                Checkbox {
                                    disabled = props.primaryKey.contains(column.name)
                                    checked = selected.contains(column.name)
                                    disableRipple = true
                                    tabIndex = -1
                                    color = CheckboxColor.secondary
                                }
                            }
                            ListItemText {
                                primary = ReactNode(column.ruTitle)
                            }
                        }
                        disabled = props.primaryKey.contains(column.name)
                        ListItemButton {
                            sx {
                                display = Display.contents
                            }

                            Stack {
                                spacing = responsive(0.5)
                                direction = responsive(StackDirection.column)
                                ListItemIcon {
                                    IconButton {
                                        edge = IconButtonEdge.end
                                        mui.icons.material.ArrowDropUpSharp {
                                            onClick = {
                                                onSwapHandler(column.name, -1)
                                            }
                                        }
                                    }
                                }
                                ListItemIcon {
                                    IconButton {
                                        edge = IconButtonEdge.end
                                        mui.icons.material.ArrowDropDownSharp {
                                            onClick = {
                                                onSwapHandler(column.name, 1)
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            Divider()
        }
        DialogActions {
            sx {
                alignItems = AlignItems.flexEnd
            }
            Stack {
                direction = responsive(StackDirection.row)
                spacing = responsive(2)
                Button {
                    disabled = selected.isEmpty()
                    color = ButtonColor.secondary
                    variant = ButtonVariant.outlined
                    +"Подтвердить изменения"
                    onClick = {
                        props.changeHandler(selected)
                        props.onSwapHandler(fieldsOrder)
                        props.onClose()
                    }
                }
                Button {
                    +"Отмена"
                    color = ButtonColor.error
                    variant = ButtonVariant.outlined
                    onClick = {
                        props.onClose()
                    }
                }
            }
        }
    }
}